<div class="container-fluid mt-3 department-page">
  <!-- Page header -->
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h3 class="dept-title mb-0">Department</h3>
  </div>

  <!-- Main card -->
  <div class="dept-card">
    <div class="card-body p-0">
      <!-- Loading -->
      <div *ngIf="isLoading" class="text-center py-4">
        <div class="spinner-border text-primary" role="status"></div>
        <div class="mt-2 text-muted small">Loading departments...</div>
      </div>

      <!-- Error -->
      <div *ngIf="!isLoading && loadError" class="alert alert-danger m-3">
        {{ loadError }}
      </div>

      <!-- No data -->
      <div
        *ngIf="!isLoading && !loadError && filteredDepartments.length === 0"
        class="alert alert-info m-3"
      >
        No departments found.
      </div>

      <!-- Table -->
      <div
        class="table-responsive"
        *ngIf="!isLoading && !loadError && filteredDepartments.length > 0"
      >
        <table class="table table-hover mb-0 dept-table">
          <thead>
            <tr>
              <th>Department Name</th>
              <th>Foreman Name</th>
              <th class="text-end" style="width: 160px;">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let dept of filteredDepartments">
              <td class="dept-name">
                {{ dept.department_name || '-' }}
              </td>

              <td class="foreman-name">
                {{ dept.department_Foreman_name || '-' }}
              </td>

              <td class="text-end">
                <button
                  type="button"
                  class="btn btn-sm btn-primary assign-btn"
                  (click)="goToShiftAssignment(dept)"
                >
                  <i class="fas fa-user-clock me-1"></i>
                  Assign Shifts
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
